import { SelectionChangedEvent } from "ag-grid-community";
import { InterfaceMonitoringEntity } from "domain/entity/InterfaceMonitoring/InterfaceMonitoringEntity";
import { INITIAL_EBIS_INTERFACE_MONITORING_COL_DEF } from "presentation/constant/EbisInterfaceMonitoring/EbisInterfaceMonitoringColumnDefinition";
import { useEbisInterfaceMonitoringMaintenanceVM } from "presentation/hook/EbisInterfaceMonitoring/useEbisInterfaceMonitoringMaintenanceVM";
import { useEbisInterfaceMonitoringMaintenanceTracked } from "presentation/store/EbisInterfaceMonitoring/EbisInterfaceMonitoringMaintenanceProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Loader } from "veronica-ui-component/dist/component/core";


const EbisInterfaceMonitoringTablePanel: React.FC = () => {
    const [ebisInterfaceMonitoringState] = useEbisInterfaceMonitoringMaintenanceTracked();
    const ebisInterfaceMonitoringVM = useEbisInterfaceMonitoringMaintenanceVM();
    let gridRef: any = useRef(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [showOverlay, setShowOverlay] = useState<boolean>(false);

    useEffect(() => {
        setShowOverlay(ebisInterfaceMonitoringState.isSearchLoading || (
            !ebisInterfaceMonitoringState.isSearchLoading &&
            ebisInterfaceMonitoringState.tableData &&
            ebisInterfaceMonitoringState.tableData.length) ? false : true);
    }, [ebisInterfaceMonitoringState.isSearchLoading, ebisInterfaceMonitoringState.tableData]);

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();

        ebisInterfaceMonitoringVM.onSelectedEbisInterfaceMonitoring(selectedRows);
    }, [ebisInterfaceMonitoringVM])

    const handleRowDoubleClick = useCallback(async (entity: InterfaceMonitoringEntity) => {
        setIsLoading(true);
        await ebisInterfaceMonitoringVM.onRowDoubleClick(entity).then(data => {
            setIsLoading(false);
        });
    }, [ebisInterfaceMonitoringVM])

    const memEbisInterfaceMonitoringTable = useMemo(() => {
        return (
            <NbisTable
                id='interface-monitoring-table'
                isNewColumnSetting={true}
                columns={INITIAL_EBIS_INTERFACE_MONITORING_COL_DEF}
                data={ebisInterfaceMonitoringState.tableData ?? []}
                showPaginator={false}
                editable={false}
                showAddIcon={false}
                showSearchIcon={false}
                showDeleteButton={false}
                showReloadIcon={false}
                isScrollHighlighted={true}
                selectionMode={false}
                rowSelection={"multiple"}
                isRowHighligted={true}
                handleSelectionChanged={handleSelectionChange}
                onRowDoubleClick={(e: any, entity: InterfaceMonitoringEntity) => handleRowDoubleClick(entity)}
                gridHeight="customHeight"
                customHeight="calc(100vh - 125px)"
                ref={gridRef}
                showDefaultOverlayNoRowsTemplate={showOverlay}
            />
        );
    }, [ebisInterfaceMonitoringState.tableData, handleRowDoubleClick, handleSelectionChange, showOverlay])

    return <><TableWrapper>
        {isLoading && <Loader Indicator="Spinner" size="Medium" />}
        {memEbisInterfaceMonitoringTable}
    </TableWrapper>
    </>;
}

export default memo(EbisInterfaceMonitoringTablePanel);